export default function MapEquipmentController(
  $scope,
  $rootScope,
  $timeout,
  mapService,
  $state,
  gettextCatalog,
) {
  'ngInject';

  const addToDataLayer = (data) => window.dataLayer.push(data);

  $scope.savedSearches = []; //holds the saved searches list
  $scope.lastSearchQuery;

  $scope.showingMap = true;
  $scope.showFiltersMobile = true;

  $scope.panelOffscreen = true;

  $scope.currentPage = 1;
  $scope.currentResultPage = 1; //the client paging (out of the result set)
  $scope.pages = [];
  $scope.numPerPage = 20;
  $scope.firstPage = gettextCatalog.getString('First');
  $scope.lastPage = gettextCatalog.getString('Last');
  //Equipment that we have currently selected in the asset search widget (only one)
  $scope.selectedEquipment = null;

  $scope.filterCount = 0;
  $scope.showingFilters = false;

  $scope.mapEquipmentListScrollY = 0;

  $scope.data = {};
  $scope.data.queryString = '';
  $scope.data.facets = {};
  $scope.data.tagFilters = [];

  $scope.tagFilters = {};

  // Needed for asset type attribute filter.
  const assetTypeSettting = () => {
    $scope.tagFilters = mapService.tagFilters;
  };

  assetTypeSettting();
  $scope.isEquipmentDetail = function () {
    return $state.includes('map.equipment.detail');
  };
  $scope.toggleFilters = function () {
    $scope.showingFilters = !$scope.showingFilters;
  };

  //Get all of the filters
  $scope.showingMapButtonPressed = function () {
    if ($state.includes('map.equipment.detail')) {
      $scope.showingMap = false;
      $scope.panelOffscreen = false;
      $state.go('map.equipment');
    } else {
      $scope.panelOffscreen = !$scope.panelOffscreen;
      $scope.showingMap = !$scope.showingMap;
    }
  };

  $scope.isShowingMap = function () {
    let onEquipmentDetail = $state.includes('map.equipment.detail');

    return $scope.showingMap || onEquipmentDetail;
  };

  //NOTE: these scope on event listeners should in time be replaced by watches on the map service.
  $scope.$on('map-moveend', function (event, args) {
    $scope.search(false); //Don't udpate the map on move........the map will do this itself
  });

  $scope.isLoading = function () {
    return mapService.loading || !mapService.equipmentResponseData;
  };

  $scope.$on('map-click', function (event, args) {
    if ($scope.facetFiltersShowing === true) {
      $scope.toggleFilters();
    }

    $scope.facetFiltersShowing = false;
    $scope.$apply();
  });

  //when the map service has updated its assets
  $scope.$on('mapservice-updated', function (event, args) {
    $scope.errorFlag = false;

    $scope.responseData = mapService.equipmentResponseData;

    $scope.calculatePages();
  });

  $scope.$on('equip-search-error', function (event, args) {
    $scope.errorFlag = true;
    $scope.errorText = args.text;
  });

  $scope.filteredEquipment = [];

  $scope.isFiltered = false;

  $scope.clearSearch = function () {
    $scope.isFiltered = false;
    $scope.data.queryString = '*';
  };

  //Refresh the entire search query...and reset hte pages
  $scope.refreshSearch = function () {
    $scope.currentPage = 1;
    $scope.selectedPage = 1;

    //This is where we would do the map move broadcast event
    $scope.search(true);
  };

  $scope.$on('map-filter-update', function () {
    if (mapService.getIsMapLoaded()) {
      mapService.setFacets($scope.facets);
      mapService.setTagFilters($scope.tagFilters);

      mapService.setSelectedEquipment(null);
      //when no filters applied will pass SEARCH_MODE.IN_MAP_BOUNDARY flag in the event to prevent map zooming out
      const payload =
        $scope.filterCount === 0
          ? { searchMode: mapService.SEARCH_MODE.IN_MAP_BOUNDARY }
          : undefined;
      $scope.$emit('assets-onupdate', payload);
      $state.go('map.equipment');
    }
  });
  $scope.clearFacets = function () {
    for (let facet in $scope.facets) {
      for (let facetItem in $scope.facets[facet]) {
        $scope.facets[facet][facetItem]._selected = false;
      }
    }
    mapService.setFacets($scope.facets);
    $scope.$emit('assets-onupdate');
  };

  $scope.isFacetsApplied = function () {
    for (let facet in $scope.facets) {
      for (let facetItem in $scope.facets[facet]) {
        if ($scope.facets[facet][facetItem]._selected) {
          return true;
        }
      }
    }
    return false;
  };

  $scope.onClickFiltersButton = function () {
    $scope.facetFiltersShowing = !$scope.facetFiltersShowing;
  };

  //calculate the number of pages and paged result set for client
  $scope.calculatePages = function () {
    if (!mapService.equipmentResponseData) return;
    if (!mapService.equipmentResponseData.data.hits) return;

    delete $scope.pagedResults;

    let responseData = mapService.equipmentResponseData;

    $scope.pages = [];
    $scope.numPages = Math.ceil(responseData.data.total / mapService.getLimit());
    $scope.currentPage = Math.floor(
      (responseData.data.cursor / responseData.data.total) * $scope.numPages,
    );

    let concurrentPages = 1;
    let cursor = $scope.currentPage - Math.ceil(concurrentPages / 2);
    let addedPages = 0;

    if (cursor < 0) {
      cursor = 0;
    }

    $scope.showingLastPage = false;
    $scope.showingFirstPage = false;

    while ($scope.pages.length < concurrentPages) {
      if (cursor < $scope.numPages) {
        $scope.pages.push(cursor + 1);
        cursor++;

        if (cursor === 1) {
          $scope.showingFirstPage = true;
        }

        if (cursor === $scope.numPages) {
          $scope.showingLastPage = true;
        }
      } else {
        break;
      }
    }

    $timeout(function () {
      $scope.pagedResults = angular.copy(responseData.data.hits);
    }, 1);
  };

  $scope.selectPage = function (page) {
    $scope.selectedPage = page;

    mapService.requestedCursor = ($scope.selectedPage - 1) * mapService.getLimit();
    $rootScope.$broadcast('selected-page');

    $scope.calculatePages();
  };

  $scope.sinceForPage = function (page, limit) {
    return (page - 1) * limit;
  };

  $scope.isDirty = false;

  //call the equipment search api if it is users first call erase old filteredAssets
  //if usergroups-page then add new key to assets returned to keep track if which ones are picked or not.
  //else just return the assets.
  //If broadcast results this will update the map and other parent scopes
  $scope.search = function (broadcastResults) {
    $scope.isDirty = false;

    let options = {};
    options.limit = $scope.limit || 500;
    if ($scope.selectedPage) {
      options.since = $scope.sinceForPage($scope.selectedPage, $scope.limit);
    }

    mapService.setFilters($scope.filters);
    mapService.setQueryString($scope.data.queryString);

    if (broadcastResults) {
      $rootScope.$broadcast('assets-onupdate');
    }
  };

  $scope.selectEquipment = function (equipment) {
    mapService.setSelectedEquipment(equipment);
    $rootScope.$broadcast('asset-onupdate');
  };

  $scope.showSearch = true;

  $scope.submitQuery = function () {
    $state.go('map.equipment');
    $scope.panelOffscreen = false;
    $scope.showingMap = false;
    $scope.refreshSearch();
  };

  $scope.toggleEquipmentList = () => {
    const event = $scope.panelOffscreen ? 'mapEquipmentListExpanded' : 'mapEquipmentListCollapsed';
    $scope.panelOffscreen = !$scope.panelOffscreen;

    addToDataLayer({
      event,
    });
  };
}
